import React from 'react';
import { Link } from 'react-router-dom';

const CardApi: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">
      <div className="border-b border-gray-200 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="inline-block mb-4">
            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold">
              Card API
            </span>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            카드 데이터 API
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            카드 승인내역, 사용내역, 통합관리 등 금융 데이터를 안전하게 제공합니다
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-xl border-2 border-gray-200 p-12 mb-12">
          <div className="flex items-center gap-3 mb-12">
            <div className="text-blue-600">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              카드 사용내역 API
            </h2>
          </div>

          <div className="mb-12">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              엔드포인트
            </h3>
            <div className="bg-gray-900 text-green-400 p-6 rounded-lg font-mono text-sm">
              <span className="inline-block px-3 py-1 bg-yellow-500 text-yellow-900 rounded font-bold mr-3">GET</span>
              <span className="text-gray-100">/api/v1/card/transactions</span>
            </div>
          </div>

          <div className="mb-12">
            <h3 className="text-xl font-bold text-gray-900 mb-6">
              보안 정책
            </h3>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
              <div className="flex items-start gap-4">
                <div className="p-2 bg-yellow-400 rounded-lg">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <p className="text-yellow-900 font-semibold mb-3">
                    <strong>중요:</strong> 카드 데이터는 민감한 금융 정보입니다. 모든 통신은 HTTPS로 암호화되며,
                    개인정보보호법 및 신용정보법을 준수합니다.
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">
                      HTTPS 암호화
                    </span>
                    <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">
                      개인정보보호법 준수
                    </span>
                    <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold">
                      신용정보법 준수
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-12">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              응답 예시
            </h3>
            <div className="bg-gray-900 text-gray-100 p-6 rounded-lg font-mono text-sm overflow-x-auto">
              <pre>{`{
  "success": true,
  "data": {
    "transactions": [
      {
        "transaction_id": "txn_12345",
        "amount": 45000,
        "merchant": "스타벅스 강남점",
        "category": "식음료",
        "transaction_date": "2025-10-28T14:30:00Z"
      }
    ],
    "total_amount": 450000,
    "transaction_count": 32
  }
}`}</pre>
            </div>
          </div>

          <Link
            to="/developer-tools/api-test"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-lg"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            API 테스트하기
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardApi;
